export function normalizeCustomFieldsForApi(rows) {
  if (!Array.isArray(rows)) return [];
  return rows
    .map((row) => ({
      fieldId: String(row?.fieldId ?? '').trim(),
      label: String(row?.label ?? '').trim(),
      value: String(row?.value ?? '').trim(),
    }))
    .filter((row) => row.fieldId || row.label.length > 0);
}

export function customFieldsFromProspect(prospect) {
  const raw = prospect?.customFields;
  if (!Array.isArray(raw)) return [];
  return raw
    .map((f) => ({
      fieldId: String(f?.fieldId ?? '').trim(),
      label: String(f?.label ?? '').trim(),
      value: String(f?.value ?? '').trim(),
    }))
    .filter((f) => f.label);
}

export function customFieldRowsFromDefinitions(definitions, savedValues) {
  const defs = Array.isArray(definitions) ? definitions : [];
  const saved = customFieldsFromProspect({ customFields: savedValues });
  return defs.map((def) => {
    const fieldId = String(def?.fieldId ?? '').trim();
    const label = String(def?.label ?? '').trim();
    const hit = saved.find(
      (s) =>
        (fieldId && s.fieldId === fieldId) ||
        s.label.toLowerCase() === label.toLowerCase(),
    );
    return {
      id: fieldId || label,
      fieldId,
      label,
      value: hit?.value ?? '',
    };
  });
}

/** @deprecated — utiliser customFieldRowsFromDefinitions */
export function newCustomFieldRow(partial = {}) {
  const id =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `cf-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  return {
    id,
    fieldId: partial.fieldId ?? '',
    label: partial.label ?? '',
    value: partial.value ?? '',
  };
}

export function customFieldRowsFromSaved(saved) {
  return customFieldsFromProspect({ customFields: saved }).map((f) =>
    newCustomFieldRow(f),
  );
}
